import { useRef, useEffect, useState } from 'react';

interface EditableStringInputProps {
    children?: React.ReactNode;
    editable:boolean;
    value:string;
    maxLength?:number;
    inputDivClassName?:string;
    inputClassName?:string;
    spanDivClassName?:string;
    spanClassName?:string;
    onEditStart : () => void,
    onEditEnd : () => void,
    onValueChanged : (v:string) => void;
}

function EditableStringInput(props:EditableStringInputProps) { 
  const [isEditing, setIsEditing] = useState(false);
  const internalRef = useRef<HTMLInputElement>(null);
  const debounceRef = useRef<NodeJS.Timeout|null>(null);

  function valueChangeWithDebounce(newVal:string) {
    if(debounceRef.current!=null) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      props.onValueChanged(newVal);
    }, 150);
  }


  useEffect(() => {
    if (isEditing && internalRef.current) {
      internalRef.current.focus();
    }
  }, [isEditing]);

  const handleEdit = () => {
    if(props.editable) {
        setIsEditing(true);
        props.onEditStart();
    }
  };

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if(event.key == 'Enter') {
      valueChangeWithDebounce(internalRef.current?.value || '');
      setIsEditing(false);
      props.onEditEnd();
    }
  }

  function handleBlur(event: React.ChangeEvent<HTMLInputElement>) { 
    valueChangeWithDebounce(event.target.value);
    setIsEditing(false);
    props.onEditEnd();
  };

  return isEditing ? (
    <div className={props.inputDivClassName}>
      <input className={props.inputClassName} ref={internalRef} 
              onBlur={handleBlur} 
              onKeyDown={handleKeyDown}              
              defaultValue={props.value} 
              maxLength={props.maxLength}/>
    </div>
  ) : (
    <div className={props.spanDivClassName} onClick={handleEdit} style={props.editable?{cursor: 'pointer'}:{}}>
      <span className={props.spanClassName} >{props.value}</span>
    </div>
  );
}

export default EditableStringInput;